export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/stephanie-krist-4dd6b5d18547be037bc081d183de2830.jpg";